// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://servidor.elabochoa.com.mx",    // Servidor Express local
  // apiUrl: "http://localhost:8500",    // Servidor Express local
  // --- Producción (descomentar según cliente) ---
  // apiUrl: "https://servidor.labdelsur.com.mx",
  // apiUrl: "https://servidor.elabochoa.com.mx",
  // apiUrl: "https://servidor.laboratoriospromolab.mx",
  // apiUrl: "https://servidor.labmedicadiamante.com.mx",
  // apiUrl: "https://servidor.sanjeronimolabs.com.mx",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
